import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Moment from "react-moment";
import Layout from "./../layouts/Index";
import BlockLoader from "./../contentloaders/BlockLoader";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  Table,
  Form,
  Button,
  Modal,
  FormControl,
  InputGroup,
} from "react-bootstrap";
import {
  getCategories,
  getMoreCategories,
  addCategory,
  editCategory,
  searchCategory,
} from "./../../store/actions/CategoryActions";
import { getSuppliers } from "./../../store/actions/SupplierActions";
import { createSchema } from "./../../helpers/validation/category";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { FaPlus, FaSearch } from "react-icons/fa";

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,

      editModal: false,

      moq_id: null,

      loading: false,

      category: {},

      search: "",
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });

    const res = await this.props.getCategories();

    if (res) {
      this.setState({ loading: false });
    }

    await this.props.getSuppliers();
  };

  toggleModal = (id = null) => {
    // console.log(id);

    this.setState({ showModal: !this.state.showModal, moq_id: id });
  };

  toggleEditModal = (category = null) => {
    this.setState({
      editModal: !this.state.editModal,
      category: category === null ? {} : category,
    });
  };

  createCategory = async (values) => {
    try {
      this.setState({ loading: true });

      const result = await this.props.addCategory(values);

      if (result) {
        toast.success("New Category Created Successfully !", {
          position: "bottom-center",
        });

        this.setState({ showModal: false, loading: false });

        return this.props.history.push("/admin/categories");
      }
    } catch (error) {
      this.setState({ loading: false });

      console.log(error);
    }
  };

  editCategory = async (values) => {
    try {
      this.setState({ loading: true });

      const { category } = this.state;

      const result = await this.props.editCategory(category.id, values);

      if (result) {
        toast.success("New Category Updated Successfully !", {
          position: "bottom-center",
        });

        this.setState({ editModal: false, loading: false });

        await this.props.getCategories();
      }
    } catch (error) {
      this.setState({ loading: false });

      console.log(error);
    }
  };

  fetchMoreCategories = async () => {
    try {
      this.setState({ loading: true });

      const {
        categories: { next_page },
      } = this.props;

      const result = await this.props.getMoreCategories(next_page);

      if (result) {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log(error);
    }
  };

  searchCategory = async () => {
    try {
      let obj = { name: this.state.search };

      this.setState({ loading: true });

      const result = await this.props.searchCategory(obj);

      if (result.length > 0) {
        console.log(result);
        toast.success("Category Found !", {
          position: "bottom-center",
        });

        return this.props.history.push(`/admin/categories/${result[0].id}`);
      }
      else {
        toast.warning("Category Not Found!", {
          position: "bottom-center",
        });
      }
    } catch (error) {
        if (error.response !== undefined && (error.response.status === 404 || error.response.status === 400)) {
          toast.warning("Category Not Found!", {
            position: "bottom-center",
          });
        }
      } finally {
        this.setState({ loading: false });
      }
  };

  keyPress = async (e) => {
    try {
      if (e.keyCode === 13) {
        await this.searchCategory();
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleChange = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { loading, showModal, editModal, category, search } = this.state;

    const {
      categories,
      categories: { page, pages },
    } = this.props;

    return (
      <Layout>
        <Col sm="12" style={{ minHeight: "80vh", padding: "1.5em 0" }}>
          <Container>
            <Row>
              <Col xs="12" md="6" lg="4" className="mb-3 mx-auto">
                <Form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    await this.searchCategory();
                  }}
                >
                  <InputGroup>
                      <FormControl
                        type="text"
                        placeholder="Search Category Name"
                        value={search}
                        onKeyDown={this.keyPress}
                        onChange={this.handleChange}
                        className="rounded-pill shadow-sm"
                      />
                      {/* Clear Button (X) */}
                      {(this.state.search?.trim()) && (
                        <Button
                          variant="outline-secondary"
                          onClick={() => {
                            this.setState({ search: "" });
                          }}
                          className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                          style={{
                            width: "40px",
                            height: "40px",
                            padding: 0,
                          }}
                        >
                          ×
                        </Button>
                      )}
                      {/* Search Button */}
                      <Button
                        variant="success"
                        type="submit"
                        disabled={
                          !this.state.search?.trim()
                        }
                        className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                        style={{
                          width: "40px",
                          height: "40px",
                          padding: 0,
                        }}
                      >
                        <FaSearch size={16} />
                      </Button>
                    </InputGroup>
                </Form>
              </Col>

              {/* Responsive header and actions */}
              <Col sm="12" className="mb-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                  <h3 className="mb-0">Categories</h3>

                  {loading ? (
                    <div style={{ width: "40px", height: "32px" }}>
                      <BlockLoader
                        width="40px"
                        height="32"
                        innerHeight="100%"
                        innerWidth="100%"
                        style={{
                          borderRadius: "4px",
                          backgroundColor: "#e0e0e0",
                        }}
                      />
                    </div>
                  ) : (
                    <Button
                      variant="success"
                      size="sm"
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "32px", height: "32px", padding: "0" }}
                      onClick={() => this.toggleModal()}
                    >
                      <FaPlus size={14} />
                    </Button>
                  )}
                </div>
              </Col>

              {/* Responsive Table */}
              <Col xs={12}>
              {!loading && (
                <div style={{ overflowX: "auto" }}>
                <Table
                  striped
                  bordered
                  hover
                  size="lg"
                  variant="light"
                  responsive="sm"
                  className="categories-table"
                >
                    <thead>
                      <tr>
                        <th>#</th>

                        <th>Product Name</th>

                        <th>Created At</th>

                        <th>Status</th>

                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {categories.data.map((category, i) => (
                        <tr key={i}>
                          <td data-label="#"> {i + 1}</td>

                          <td data-label="Category Name">{category.name}</td>

                          <td data-label="Created At">
                            <Moment format="DD/MM/YYYY">
                              {category.date_created}
                            </Moment>
                          </td>

                          <td data-label="Status">
                            {category.status === 1 ? "Active" : "Inactive"}
                          </td>

                          <td>
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => this.toggleEditModal(category)}
                            >
                              Edit
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                )}
              </Col>

              <Col sm="12">
                {loading && (
                  <BlockLoader
                    width="100%"
                    height="400px"
                    innerWidth="100%"
                    innerHeight="100%"
                  />
                )}
              </Col>

              {page < pages && (
                <Col
                  sm="12"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "2em",
                  }}
                >
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={() => this.fetchMoreCategories()}
                    disabled={loading}
                  >
                    {loading === true ? "Loading ..." : "Load More"}
                  </Button>
                </Col>
              )}
            </Row>
          </Container>
          </Col>
          {/* Add responsive table styles */}
          <style>{`
            @media (max-width: 767px) {
            .categories-table thead {
              display: none;
            }
            .categories-table, .categories-table tbody, .categories-table tr, .categories-table td {
              display: block;
              width: 100%;
            }
            .categories-table tr {
              margin-bottom: 1rem;
              border-bottom: 2px solid #dee2e6;
            }
            .categories-table td {
              text-align: right;
              padding-left: 50%;
              position: relative;
              border: none;
              border-bottom: 1px solid #dee2e6;
            }
            .categories-table td:before {
              content: attr(data-label);
              position: absolute;
              left: 0;
              width: 50%;
              padding-left: 1rem;
              font-weight: bold;
              text-align: left;
              white-space: nowrap;
            }
            }
          `}</style>
        {/* New Category Modal */}
        <Modal show={showModal} onHide={this.toggleModal}>
          <Modal.Header closeButton>
            <Modal.Title>New Category</Modal.Title>
          </Modal.Header>

          <Formik
            initialValues={{ name: "" }}
            validationSchema={createSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              values.status = 1;

              this.createCategory(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <div>
                <Modal.Body>
                  <Form.Group as={Row} controlId="name">
                    <Form.Label column sm="3">
                      Category Name
                    </Form.Label>

                    <Col sm="9">
                      <Form.Control
                        type="text"
                        placeholder="Name"
                        name="name"
                        isValid={touched.name && !errors.name}
                        isInvalid={errors.name && touched.name}
                        value={values.name}
                        onChange={handleChange}
                      />

                      {errors.name && touched.name && (
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={this.toggleModal}>
                    Close
                  </Button>

                  <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    Create Category Name
                  </Button>
                </Modal.Footer>
              </div>
            )}
          </Formik>
        </Modal>

        {/* Edit Color Modal */}
        <Modal show={editModal} onHide={this.toggleEditModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Category Name</Modal.Title>
          </Modal.Header>

          <Formik
            initialValues={{
              name:
                category.name !== undefined || category.name !== null
                  ? category.name
                  : "",
              status:
                category.status !== undefined || category.status !== null
                  ? category.status
                  : 1,
            }}
            validationSchema={createSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              this.editCategory(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <div>
                <Modal.Body>
                  <Form.Group as={Row} controlId="label">
                    <Form.Label column sm="3">
                      Category Name
                    </Form.Label>

                    <Col sm="9">
                      <Form.Control
                        type="text"
                        placeholder="Name"
                        name="name"
                        isValid={touched.name && !errors.name}
                        isInvalid={errors.name && touched.name}
                        value={values.name}
                        onChange={handleChange}
                      />

                      {errors.name && touched.name && (
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="status">
                    <Form.Label column sm="3">
                      Status
                    </Form.Label>

                    <Col sm="9">
                      <Form.Control
                        as="select"
                        isValid={touched.status && !errors.status}
                        defaultValue={values.status}
                        isInvalid={errors.status && touched.status}
                        name="status"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option>Choose ...</option>

                        <option value={0}>Inactive</option>

                        <option value={1}>Active</option>
                      </Form.Control>

                      {errors.status && touched.status && (
                        <Form.Control.Feedback type="invalid">
                          {errors.status}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={this.toggleEditModal}
                  >
                    Close
                  </Button>

                  <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    Edit Category Name
                  </Button>
                </Modal.Footer>
              </div>
            )}
          </Formik>
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    categories: state.categories,

    suppliers: state.suppliers,
  };
};

export default connect(mapStateToProps, {
  getCategories,
  addCategory,
  getSuppliers,
  getMoreCategories,
  editCategory,
  searchCategory,
})(withRouter(Index));
